import React from "react";

export const ProductImagePlaceholder = () => {
  return (
    <svg
      width="339"
      height="260"
      viewBox="0 0 339 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="339" height="236" rx="8" fill="#F6F6F6" />
      <mask
        id="mask0_433_27300"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="92"
        y="52"
        width="156"
        height="156"
      >
        <rect x="92" y="52" width="156" height="156" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_433_27300)">
        <path
          d="M117.983 161.2L140.936 122.2C141.318 121.55 141.781 121.063 142.323 120.738C142.865 120.413 143.422 120.25 143.996 120.25C144.57 120.25 145.128 120.413 145.671 120.738C146.212 121.063 146.674 121.55 147.057 122.2L167.715 157.3C168.1 157.95 168.548 158.438 169.061 158.763C169.575 159.088 170.152 159.25 170.793 159.25C172.396 159.25 173.538 158.356 174.218 156.569C174.898 154.781 174.77 153.075 173.835 151.45L160.701 129.188C160.191 128.286 159.936 127.303 159.936 126.236C159.936 125.17 160.191 124.204 160.701 123.337L176.641 96.2C177.023 95.55 177.486 95.0625 178.028 94.7375C178.57 94.4125 179.127 94.25 179.701 94.25C180.275 94.25 180.833 94.4125 181.375 94.7375C181.917 95.0625 182.379 95.55 182.762 96.2L221.017 161.2C221.952 162.825 222.071 164.531 221.375 166.319C220.679 168.106 219.539 169 217.956 169H121.043C119.46 169 118.321 168.106 117.624 166.319C116.928 164.531 117.048 162.825 117.983 161.2Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const ProductDetailHolder = () => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z"
        fill="#F4F4F5"
      />
      <path
        d="M20.1667 29.1079C20.42 29.2542 20.7074 29.3312 21 29.3312C21.2926 29.3312 21.58 29.2542 21.8333 29.1079L27.6667 25.7746C27.9198 25.6285 28.13 25.4183 28.2763 25.1653C28.4225 24.9122 28.4997 24.6252 28.5 24.3329V17.6663C28.4997 17.374 28.4225 17.0869 28.2763 16.8339C28.13 16.5809 27.9198 16.3707 27.6667 16.2246L21.8333 12.8913C21.58 12.745 21.2926 12.668 21 12.668C20.7074 12.668 20.42 12.745 20.1667 12.8913L14.3333 16.2246C14.0802 16.3707 13.87 16.5809 13.7237 16.8339C13.5775 17.0869 13.5003 17.374 13.5 17.6663V24.3329C13.5003 24.6252 13.5775 24.9122 13.7237 25.1653C13.87 25.4183 14.0802 25.6285 14.3333 25.7746L20.1667 29.1079Z"
        stroke="#D4D4D8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 29.3333V21"
        stroke="#D4D4D8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.7417 16.833L21 20.9997L28.2584 16.833"
        stroke="#D4D4D8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.25 14.5586L24.75 18.8503"
        stroke="#D4D4D8"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CrossIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="#A4A4A4"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UpStockArrow = () => {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 13.5V6.5"
        stroke="#22C55E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 10L6 6.5L9.5 10"
        stroke="#22C55E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DownStockArrow = () => {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6.5V13.5"
        stroke="#FF5757"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 10L6 13.5L2.5 10"
        stroke="#FF5757"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00088 14.3996C8.00088 14.3996 13.0096 9.94743 13.0096 6.6083C13.0096 3.84208 10.7671 1.59961 8.00088 1.59961C5.23466 1.59961 2.99219 3.84208 2.99219 6.6083C2.99219 9.94743 8.00088 14.3996 8.00088 14.3996Z"
        stroke="#484848"
      />
      <path
        d="M9.60109 6.39971C9.60109 7.28337 8.88474 7.99971 8.00109 7.99971C7.11743 7.99971 6.40109 7.28337 6.40109 6.39971C6.40109 5.51606 7.11743 4.79971 8.00109 4.79971C8.88474 4.79971 9.60109 5.51606 9.60109 6.39971Z"
        stroke="#484848"
      />
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="8.25" stroke="#E1544C" strokeWidth="1.5" />
      <path
        d="M5.5 9H12.5"
        stroke="#E1544C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ScannedArrow = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#F1F1F4" />
      <path
        d="M7 5L12 10L7 15"
        stroke="#585858"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
